import React, { useState } from 'react';
import { useResume } from '../context/ResumeContext';
import { getRegistryItem } from '../registry';
import { X } from 'lucide-react';

export default function InterestsSection({ sectionId }) {
  const { activeResume, updateField } = useResume();
  const list = activeResume?.[sectionId] || [];
  const [inputValue, setInputValue] = useState('');
  const meta = getRegistryItem(sectionId) || {};

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const val = inputValue.trim().replace(/,/g, '');
      if (val && !list.includes(val)) {
        const nextList = [...list, val];
        updateField(sectionId, nextList);
      }
      setInputValue('');
    }
  };

  const handleDeleteItem = (itemToDelete) => {
    const nextList = list.filter(item => item !== itemToDelete);
    updateField(sectionId, nextList);
  };

  const labelStyle = {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    marginBottom: '8px',
    display: 'block',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div>
        <label style={labelStyle}>{meta.title || 'Items'}</label>
        <input
          type="text"
          className="p-input"
          placeholder={`Type an item (e.g. Chess) and press Enter...`}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{ width: '100%' }}
        />
      </div>

      {list.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
          {list.map((item, idx) => (
            <span
              key={idx}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 10px',
                background: 'var(--brand-light)',
                border: '1px solid var(--brand-border)',
                borderRadius: 20,
                color: 'var(--brand)',
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {item}
              <button
                type="button"
                onClick={() => handleDeleteItem(item)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'var(--brand)',
                  cursor: 'pointer',
                  fontSize: 10,
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <X size={10} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
